// src/components/Button.js

import React from 'react';

function Button({ children, onClick, variant = 'primary', disabled = false, type = 'button', className = '' }) {
  // Estilos base que todos los botones compartirán
  const baseStyles = 'py-2 px-4 rounded-lg font-bold transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 transform hover:scale-105';

  // Diferentes estilos según la variante
  const variantStyles = {
    primary: 'bg-principal text-white focus:ring-principal',
    secondary: 'bg-gray-200 text-gray-800 hover:bg-gray-300 focus:ring-gray-400',
    danger: 'bg-red-500 text-white hover:bg-red-600 focus:ring-red-500',
    success: 'bg-green-500 text-white hover:bg-green-600 focus:ring-green-500',
    accent: 'bg-acento text-white hover:bg-yellow-500 focus:ring-acento',
  };

  // Estilos para cuando el botón está deshabilitado
  const disabledStyles = 'opacity-50 cursor-not-allowed scale-100';

  // Combinamos todas las clases
  const combinedClassName = `
    ${baseStyles}
    ${variantStyles[variant]}
    ${disabled ? disabledStyles : ''}
    ${className}
  `;

  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      className={combinedClassName.trim()}
    >
      {children}
    </button>
  );
}

export default Button;